import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AvatarIcon, CountryFlag } from "@/lib/identity";
import { Heading } from "./NKDaily";

export default function CountryWarAdmin() {
  const [war, setWar] = useState(null);
  const [lb, setLb] = useState({ NG: [], GH: [] });

  useEffect(() => {
    const load = async () => {
      try {
        const [w, ng, gh] = await Promise.all([
          api.get("/season/country-war"),
          api.get("/season/leaderboard", { params: { country: "NG", limit: 5 } }),
          api.get("/season/leaderboard", { params: { country: "GH", limit: 5 } }),
        ]);
        setWar(w.data);
        setLb({ NG: ng.data.entries || [], GH: gh.data.entries || [] });
      } catch { /* */ }
    };
    load(); const id = setInterval(load, 15000); return () => clearInterval(id);
  }, []);

  if (!war) return <><Heading title="Country War" /><p className="text-nk-mute text-sm">Loading…</p></>;

  const total = (war.rows || []).reduce((a, b) => a + (b.total_score || 0), 0);

  return (
    <div className="space-y-6">
      <Heading title="Country War" subtitle="Live aggregate of every score earned by every player. Great social-media fodder." />

      <section className="space-y-3">
        {(war.rows || []).map((r) => {
          const pct = total > 0 ? (r.total_score / total) * 100 : 0;
          return (
            <div key={r.country} className="nk-card p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <CountryFlag country={r.country} size={20} />
                  <p className="font-display text-2xl font-medium">{r.country === "NG" ? "Nigeria" : "Ghana"}</p>
                  <span className="text-xs text-nk-dim font-mono">{(r.player_count || 0).toLocaleString()} players</span>
                </div>
                <p className="font-display text-2xl font-medium text-nk-accent font-mono">{r.total_score.toLocaleString()}</p>
              </div>
              <div className="h-2 bg-nk-line rounded-full overflow-hidden">
                <div className="h-full bg-nk-accent transition-all" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {["NG", "GH"].map((c) => (
          <div key={c} className="nk-card p-4">
            <div className="flex items-center gap-2 mb-3">
              <CountryFlag country={c} size={14} />
              <p className="font-display text-lg">Top contributors · {c === "NG" ? "Nigeria" : "Ghana"}</p>
            </div>
            <div className="space-y-1.5">
              {lb[c].map((r) => (
                <div key={r.user_id} className="flex items-center gap-2 text-sm">
                  <span className="font-mono text-xs text-nk-dim w-5">#{r.rank}</span>
                  <AvatarIcon id={r.avatar} size={20} />
                  <span className="flex-1 truncate">{r.username}</span>
                  <span className="font-mono text-nk-accent">{(r.season_score || 0).toLocaleString()}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
